// extracted by mini-css-extract-plugin
module.exports = {"webhookList":"style_webhookList__2f8Ni"};